import { Navigate } from 'react-router-dom';
import { NAVIGATION_ROUTE } from '@/utils/CONST';

const RedirectToMainPage = () => {
    return <Navigate to={`/${NAVIGATION_ROUTE}`} replace />;
};

export default RedirectToMainPage;
